// Mirrors amplify/shared/normalize.ts — keep in sync.
// Used to derive Report.searchName / searchNativeName / searchRegId values.

const LEGAL_SUFFIXES = [
  'incorporated',
  'corporation',
  'corp',
  'company',
  'inc',
  'co',
  'ltd',
  'limited',
  'llc',
  'lp',
  'llp',
  'plc',
  'gmbh',
  'ag',
  'kg',
  'ohg',
  'gbr',
  'bv',
  'nv',
  'sa',
  'sas',
  'sarl',
  'srl',
  'spa',
  'oy',
  'ab',
  'group',
  'holdings',
  'holding',
  'בעמ',
];

const SUFFIX_PATTERN = new RegExp(`(\\s+(?:${LEGAL_SUFFIXES.join('|')}))+$`);

export function normalizeName(input) {
  if (!input) return '';

  let s = String(input).toLowerCase().trim();

  // Strip quotes silently so Hebrew "בע\"מ" → "בעמ" before suffix matching.
  s = s.replace(/['"״׳`]/g, '');
  // Other punctuation becomes whitespace.
  s = s.replace(/[-.,/\\_()[\]{}]/g, ' ');
  s = s.replace(/\s+/g, ' ').trim();

  return s.replace(SUFFIX_PATTERN, '').trim();
}

export function normalizeRegId(input) {
  if (!input) return '';
  return String(input).toLowerCase().replace(/[\s\-_./\\]/g, '').trim();
}
